'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { BarChart3, Grid3x3, Network, Lock, FileText, Grid, LogOut, Rocket } from 'lucide-react'

export function Sidebar() {
  const pathname = usePathname()

  const items = [
    { icon: BarChart3, label: 'Overview', href: '/' },
    { icon: Rocket, label: 'Deployments', href: '/deployments' },
    { icon: Lock, label: 'Honeypots', href: '/honeypots' },
    { icon: Grid3x3, label: 'Nodes / Hosts', href: '/nodes' },
    { icon: Network, label: 'Network Control', href: '/network' },
    { icon: Grid, label: 'Templates', href: '/templates' },
    { icon: FileText, label: 'Raw Logs', href: '/logs' },
  ]

  return (
    <aside className="w-56 bg-sidebar border-r border-sidebar-border flex flex-col h-screen fixed left-0 top-0">
      <div className="p-6 border-b border-sidebar-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded bg-sidebar-primary flex items-center justify-center">
            <span className="text-sidebar-primary-foreground font-bold text-sm">X</span>
          </div>
          <div className="flex flex-col">
            <h1 className="font-bold text-sidebar-primary-foreground text-sm">XYBERAH</h1>
            <p className="text-xs text-sidebar-foreground opacity-60">Security Platform</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {items.map((item) => {
          const Icon = item.icon
          const isActive = pathname === item.href || (item.href === '/' && pathname === '')
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-sidebar-primary text-sidebar-primary-foreground'
                  : 'text-sidebar-foreground hover:bg-sidebar-accent'
              }`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </nav>

      <div className="p-4 border-t border-sidebar-border">
        <div className="flex items-center gap-3 px-4 py-3 rounded-lg text-sidebar-foreground hover:bg-sidebar-accent cursor-pointer transition-colors">
          <LogOut size={18} />
          <span className="text-sm font-medium">Logout</span>
        </div>
      </div>
    </aside>
  )
}
